import { render, staticRenderFns } from "./PersonProfile.vue?vue&type=template&id=5cd7e09b&scoped=true&"
import script from "./PersonProfile.vue?vue&type=script&lang=js&"
export * from "./PersonProfile.vue?vue&type=script&lang=js&"
import style0 from "./PersonProfile.vue?vue&type=style&index=0&id=5cd7e09b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd7e09b",
  null
  
)

export default component.exports